import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ARTICLES } from "../data/articles";
import { Seo } from "../components/Seo";
import { MaskedLine, Reveal } from "../components/Reveal";
import { CTABanner } from "../components/sections/CTABanner";

export default function Insights() {
  return (
    <>
      <Seo
        title="IT Insights for Small Business | Sempresera"
        description="Data-backed IT guidance for small businesses: breach costs, the human element in security, and ransomware-proof backup — research from IBM, Verizon, Sophos and the FBI."
        path="/insights"
      />

      <section className="mx-auto max-w-7xl px-5 pb-24 pt-36 md:px-8 md:pt-44" data-testid="insights-page">
        <MaskedLine delay={0.1}>
          <span className="eyebrow">Insights</span>
        </MaskedLine>
        <h1 className="mt-6 max-w-3xl font-display text-4xl font-black leading-[1.02] tracking-tighter md:text-6xl">
          <MaskedLine delay={0.25}>
            <span className="text-metallic">IT tips, backed by</span>
          </MaskedLine>
          <MaskedLine delay={0.4}>
            <span className="text-metallic">real numbers.</span>
          </MaskedLine>
        </h1>
        <MaskedLine delay={0.55}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-[#C9D2DE]">
            No vendor fear-mongering. Research from IBM, Verizon, Sophos and the FBI — translated into plain
            decisions for small businesses.
          </p>
        </MaskedLine>

        <div className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-3">
          {ARTICLES.map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.08}>
              <Link
                to={`/insights/${a.slug}`}
                data-testid={`insights-card-${a.slug}`}
                className="group glass flex h-full flex-col justify-between p-8 transition-all duration-300 hover:-translate-y-1 hover:border-brand/40"
              >
                <div>
                  <div className="flex items-center gap-3">
                    <span className="font-display text-xs font-bold uppercase tracking-[0.25em] text-brand">{a.tag}</span>
                    <span className="text-xs text-zinc-600">{a.readTime}</span>
                  </div>
                  <h2 className="mt-4 font-display text-xl font-bold leading-snug tracking-tight text-white">{a.title}</h2>
                  <p className="mt-3 text-sm leading-relaxed text-[#C9D2DE]">{a.excerpt}</p>
                </div>
                <span className="mt-8 inline-flex items-center gap-2 font-display text-xs font-bold uppercase tracking-[0.2em] text-[#A8B4C2] transition-colors duration-300 group-hover:text-brand">
                  Read <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <CTABanner />
    </>
  );
}
